var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-M---SFY---PDP-Final",
    transform: "translate(-20.000000, -927.000000)",
    fill: "#1D1C1C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(19.000000, 819.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4634992_diamond_jewel_icon",
    transform: "translate(0.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.66,6.06 C24.6755002,5.99085806 24.6755002,5.91914194 24.66,5.85 C24.66,5.85 24.66,5.85 24.66,5.85 C24.6511178,5.77136939 24.6236997,5.6959697 24.58,5.63 L24.58,5.63 L21,0.39 C21.0051274,0.350164311 21.0051274,0.309835689 21,0.27 C20.9043281,0.0810822308 20.7000232,-0.0270791967 20.49,-2.20309881e-16 L5.28,-2.20309881e-16 C5.2097968,0.00539822953 5.14158152,0.0258628138 5.08,0.06 L5.08,0.06 C5.05014309,0.0832732492 5.02327325,0.110143093 5,0.14 C4.97060237,0.160014493 4.94373971,0.183519319 4.92,0.21 L1.09,5.57 L1.09,5.57 C1.0380016,5.64369108 1.00690348,5.73007474 1,5.82 L1,5.82 C0.981751963,5.89558083 0.981751963,5.97441917 1,6.05 C1,6.05 1,6.05 1,6.05 L1,6.05 C0.998140994,6.07329631 0.998140994,6.09670369 1,6.12 L12.88,19.48 L12.88,19.48 L12.88,19.48 L13,19.48 L13.05,19.48 L13.11,19.48 L13.24,19.48 L13.24,19.48 L13.39,19.48 L13.39,19.48 L13.45,19.48 L13.45,19.48 L13.45,19.48 L13.45,19.48 L13.45,19.48 L13.45,19.48 L13.45,19.48 L24.45,6.19 C24.4513652,6.1700233 24.4513652,6.1499767 24.45,6.13 L24.45,6.13 C24.45,6.13 24.66,6.07 24.66,6.06 Z M12.85,1.37 L15.67,5.37 L10,5.37 L11.72,2.93 L12.85,1.37 Z M16.05,6.37 L13.2,17.37 L9.75,6.37 L16.05,6.37 Z M12.05,17.07 L2.61,6.36 L8.7,6.36 L12.05,17.07 Z M17.05,6.37 L23.11,6.37 L14.3,17.09 L17.05,6.37 Z M17.63,5.37 L20.42,1.37 L23.21,5.37 L17.63,5.37 Z M19.46,1 L16.67,5 L13.88,1 L19.46,1 Z M10.17,3.44 L9.07,5 L6.69,1.62 L6.25,1 L11.89,1 L10.17,3.44 Z M5.28,1.37 L7.67,4.74 L8.11,5.36 L2.46,5.36 L5.28,1.37 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.215618a2489c973ce3eafbb752cc3539.svg";
export { ForwardRef as ReactComponent };